// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { LinkSocialIdentityPayload } from './link-social-identity-result';

export interface UnLinkSocialIdentityResult {
  unlinkUserIndentity: LinkSocialIdentityPayload;
}
